import React from 'react';
import { Link } from 'react-router-dom';

const Datenschutz = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <Link to="/" className="inline-block mb-6 text-blue-600 hover:text-blue-800">
        ← Zurück zur Startseite
      </Link>
      
      <h1 className="text-3xl font-bold mb-6">Datenschutzerklärung</h1>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Allgemeines</h2>
        <p className="mb-4">
        Die Bollwerk-X GmbH, nachfolgend „Bollwerk-X GmbH“ oder „wir“, nimmt den Schutz Ihrer persönlichen Daten sehr ernst. Ihre personenbezogenen Daten behandeln wir vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Verantwortlicher</h2>
        <p className="mb-4">
          Verantwortlich im Sinne der Datenschutz-Grundverordnung und anderer nationaler Datenschutzgesetze der Mitgliedstaaten sowie sonstiger datenschutzrechtlicher Bestimmungen ist die:
        </p>
        <p className="mb-4">
          Bollwerk-X GmbH<br />
          Helene-Meiser-Weg 29<br />
          44227 Dortmund<br />
          Deutschland
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Arten der verarbeiteten Daten:</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>Bestandsdaten (z.B. Namen, Adressen)</li>
          <li>Kontaktdaten (z.B. E-Mail, Telefonnummern)</li>
          <li>Meta-/Kommunikationsdaten (z.B. Geräte-Informationen, IP-Adressen)</li>
          <li>Inhaltsdaten (z.B. Texteingaben, Fotografien, Videos)</li>
          <li>Zahlungsdaten (z.B. Bankverbindung, Zahlungshistorie)</li>
          <li>Nutzungsdaten (z.B. besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten)</li>
          <li>Vertragsdaten (z.B. Vertragsgegenstand, Laufzeit, Kundenkategorie)</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Kategorien der von der Verarbeitung betroffenen Personen:</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>Kunden, Interessenten, Besucher und Nutzer des Onlineangebotes, Geschäftspartner.</li>
          <li>Wir bezeichnen die betroffenen Personen zusammenfassend auch als "Nutzer".</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Zweck der Verarbeitung:</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>Zurverfügungstellung des Onlineangebotes und seiner Inhalte.</li>
          <li>Erbringung vertraglicher Leistungen, Service und Kundenpflege.</li>
          <li>Beantwortung von Kontaktanfragen und Kommunikation mit Nutzern.</li>
          <li>Marketing, Werbung und Marktforschung.</li>
          <li>Sicherheitsmaßnahmen.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">1. Verwendete Begrifflichkeiten</h2>
        <p className="mb-4">
          Personenbezogene Daten sind alle Informationen, die sich auf eine identifizierte oder identifizierbare natürliche Person beziehen. Die Verarbeitung umfasst jeden mit oder ohne Hilfe automatisierter Verfahren ausgeführten Vorgang im Zusammenhang mit personenbezogenen Daten. Der Verantwortliche ist die natürliche oder juristische Person, die über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">2. Maßgebliche Rechtsgrundlagen</h2>
        <p className="mb-4">
          Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten sind Art. 6 Abs. 1 lit. a und Art. 7 DSGVO für Einwilligungen, Art. 6 Abs. 1 lit. b DSGVO für die Verarbeitung zur Vertragserfüllung, Art. 6 Abs. 1 lit. c DSGVO für die Verarbeitung zur Erfüllung unserer rechtlichen Verpflichtungen und Art. 6 Abs. 1 lit. f DSGVO für die Verarbeitung zur Wahrung unserer berechtigten Interessen.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">3. Änderungen und Aktualisierungen der Datenschutzerklärung</h2>
        <p className="mb-4">
          Wir passen die Datenschutzerklärung an, sobald Änderungen der von uns durchgeführten Datenverarbeitungen dies erforderlich machen. Wir informieren Sie, sobald durch die Änderungen eine Mitwirkungshandlung Ihrerseits erforderlich wird.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">4. Sicherheitsmaßnahmen</h2>
        <p className="mb-4">
          Wir treffen nach Maßgabe des Art. 32 DSGVO geeignete technische und organisatorische Maßnahmen, um ein dem Risiko angemessenes Schutzniveau zu gewährleisten. Dazu gehört insbesondere die verschlüsselte Übertragung von Daten zwischen Ihrem Browser und unserem Server.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">5. Offenlegung und Übermittlung von Daten</h2>
        <p className="mb-4">
          Eine Übermittlung Ihrer Daten an Dritte erfolgt nur auf Grundlage einer gesetzlichen Erlaubnis oder Ihrer Einwilligung. Eine Datenübermittlung in Drittländer erfolgt nur unter den besonderen Voraussetzungen der Art. 44 ff. DSGVO.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">6. Übermittlungen in Drittländer</h2>
        <p className="mb-4">
          Sofern wir Daten in einem Drittland (d.h. außerhalb der Europäischen Union (EU) oder des Europäischen Wirtschaftsraums (EWR)) verarbeiten oder dies im Rahmen der Inanspruchnahme von Diensten Dritter oder Offenlegung bzw. Übermittlung von Daten an Dritte geschieht, erfolgt dies nur, wenn es zur Erfüllung unserer (vor)vertraglichen Pflichten, auf Grundlage Ihrer Einwilligung, aufgrund einer rechtlichen Verpflichtung oder auf Grundlage unserer berechtigten Interessen geschieht. Die Verarbeitung erfolgt z.B. auf Grundlage besonderer Garantien, wie der offiziell anerkannten Feststellung eines der EU entsprechenden Datenschutzniveaus (z.B. durch "Privacy Shield") oder Beachtung offiziell anerkannter spezieller vertraglicher Verpflichtungen (sogenannte "Standardvertragsklauseln").
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">7. Rechte der betroffenen Personen</h2>
        <p className="mb-4">
          Sie haben das Recht, eine Bestätigung darüber zu verlangen, ob Sie betreffende Daten verarbeitet werden und auf Auskunft über diese Daten sowie auf weitere Informationen und eine Kopie der Daten entsprechend Art. 15 DSGVO.
        </p>
        <p className="mb-4">
          Entsprechend Art. 16 DSGVO haben Sie das Recht, die Vervollständigung der Sie betreffenden Daten oder die Berichtigung der Sie betreffenden unrichtigen Daten zu verlangen.
        </p>
        <p className="mb-4">
          Sie haben nach Maßgabe des Art. 17 DSGVO das Recht zu verlangen, dass betreffende Daten unverzüglich gelöscht werden, bzw. alternativ nach Maßgabe des Art. 18 DSGVO eine Einschränkung der Verarbeitung der Daten zu verlangen.
        </p>
        <p className="mb-4">
          Sie haben das Recht zu verlangen, dass die Sie betreffenden Daten, die Sie uns bereitgestellt haben nach Maßgabe des Art. 20 DSGVO zu erhalten und deren Übermittlung an andere Verantwortliche zu fordern.
        </p>
        <p className="mb-4">
          Ferner haben Sie gem. Art. 77 DSGVO das Recht, eine Beschwerde bei der zuständigen Aufsichtsbehörde einzureichen.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">8. Widerrufsrecht</h2>
        <p className="mb-4">
          Sie haben das Recht, erteilte Einwilligungen gem. Art. 7 Abs. 3 DSGVO mit Wirkung für die Zukunft zu widerrufen.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">9. Widerspruchsrecht</h2>
        <p className="mb-4">
          Sie können der künftigen Verarbeitung der Sie betreffenden Daten nach Maßgabe des Art. 21 DSGVO jederzeit widersprechen. Der Widerspruch kann insbesondere gegen die Verarbeitung für Zwecke der Direktwerbung erfolgen.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">10. Cookies und Widerspruchsrecht bei Direktwerbung</h2>
        <p className="mb-4">
          Als "Cookies" werden kleine Dateien bezeichnet, die auf Computern der Nutzer gespeichert werden. Innerhalb der Cookies können unterschiedliche Angaben gespeichert werden. Ein Cookie dient primär dazu, die Angaben zu einem Nutzer (bzw. dem Gerät auf dem das Cookie gespeichert ist) während oder auch nach seinem Besuch innerhalb eines Onlineangebotes zu speichern. Weitere Informationen finden Sie in unserer Cookie-Richtlinie.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">11. Löschung von Daten</h2>
        <p className="mb-4">
          Die von uns verarbeiteten Daten werden nach Maßgabe der Art. 17 und 18 DSGVO gelöscht oder in ihrer Verarbeitung eingeschränkt. Sofern nicht im Rahmen dieser Datenschutzerklärung ausdrücklich angegeben, werden die bei uns gespeicherten Daten gelöscht, sobald sie für ihre Zweckbestimmung nicht mehr erforderlich sind und der Löschung keine gesetzlichen Aufbewahrungspflichten entgegenstehen. Die Daten werden gesperrt und nicht für andere Zwecke verarbeitet.
        </p>
      </section>
    </div>
  );
};

export default Datenschutz; 